import styles from './noResults.module.css'
import TEXT from "localisation";
type Props = {
    filters: any,
    removeFilter: any,
    classType: any
}

const NoResults = ({ filters, removeFilter, classType }: Props) => {

    const hasFilters = Boolean(filters.length);
    const handleRemoveFilter = (field) => {
        removeFilter(field);
    }

    let displayText = {
        "rent_pa": {
            'preText': '£',
            'title': 'Rent',
        },
        "size_ft_max": {
            'afterText':'ft²',
            'title': 'Size',
        },
        "size_m_max": {
            'afterText':'m²'
        },
        "category_code": {
            'title': 'Category'
        },
        "availability": {
            'title': "Availability"
        }
        ,
        "price": {
            'title': "Price"
        },
        "town.name": {
            'title': "Location"
        }
    }
    const HasFiltersContent = () => {
        return (
            <>
                {filters.filter(f => f.field !== 'ui:availability' && f.field !== 'ui:category_code' ).map((f, i) => {
                    let value = f.values[0];
                    let textOptions = displayText[f.field]
                    if (typeof f.values[0] === 'object') {

                        let min = 'from' in value ? [ textOptions['preText'], String(value.from) , textOptions['afterText']].filter(Boolean).join("") : 'Min';
                        let max = 'to' in value ? [ textOptions['preText'], String(value.to) , textOptions['afterText']].filter(Boolean).join("") : 'Max';
                        
                       
                        let valueText = `${min} - ${max}`;

                        return (
                            <button key={f.field || i}  onClick={() => handleRemoveFilter(f.field)}>{`${textOptions?.title || value.name}: ${valueText}`} <span>x</span></button>
                        )
                    } else if (textOptions) {
                        
                        const values = f.field === 'category_code' ? f.values.map((x) => TEXT[`FILTER_CATEGORIES_${x}`]) : f.values;
                        return (
                            <button key={f.field || i} onClick={() => handleRemoveFilter(f.field)}>{`${textOptions['title']}: ${values.join(", ")}`} <span>x</span></button>
                        )
                    }
                    return null;
                })}
            </>
        )
    }

    return (
        <div className={`${classType} ${styles.NoResultsContainer}`}>
            <div>
                <h3>No matching properties</h3>
                <p>
                    {hasFilters && ("Try removing some of the filters or search in another area ")}
                    {!hasFilters && ("There are no properties in this area")}
                </p>
                <HasFiltersContent />
            </div>
        </div>
    )
}

export default NoResults;